import jsPDF from 'jspdf';
import sioslifeLogo from '../../../../logos/sioslife-text.png';
import moment from 'moment';
import {pdfAddHorizontalLine} from './export-pdf-footer-header-utils';
import {PDF_FONT_MAIN_COLOR} from './export-pdf-font';

export function pdfFooterInfo(pdf: jsPDF, pageCounter: string) {
  pdf.setTextColor(PDF_FONT_MAIN_COLOR);
  pdf.setFontSize(8);
  pdf.setFont('Helvetica', 'Oblique');
  const pageSize = pdf.internal.pageSize;
  const pageHeight = pageSize.height;
  const pageWidth_footer = pageSize.width;
  const pageCenter = pageWidth_footer / 2;
  const posY_footer = pageHeight - 6;
  const headerMarginX = 14;
  let posX_footer = 0;

  // Add Sioslife logo to the left
  posX_footer = headerMarginX;
  pdf.addImage(sioslifeLogo, 'JPEG', posX_footer, posY_footer - 3.5, 13.5, 3.4);

  // Add date to center
  posX_footer = pageCenter - 5;
  pdf.text(moment().format('DD MMM YYYY'), posX_footer, posY_footer, {align: 'center'});

  // Add page number to the right
  posX_footer = pageWidth_footer - headerMarginX;
  pdf.text(pageCounter, posX_footer, posY_footer, {align: 'right'});

  // Horizontal line
  pdfAddHorizontalLine(pdf, 14, pageHeight - 11.5);
}
